import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

export const H1 = styled.h1`
  text-align: center;
  font-size: 20px;
  margin-top: 25px;
`;
export const H2 = styled.h1`
  text-align: center;
  font-size: 16px;
  margin-top: 10px;
`;

export const Warning = styled.h1`
  text-align: center;
  font-size: 16px;
  margin-top: 10px;
  color: red;
`;

export const LinkBlock = styled.div`
  background: #17ade3;
  display: flex;
  justify-content: center;
  margin-top: -50px;
`;

export const TableBlock = styled.div`
  width: 70%;
  display: flex;
  justify-content: center;
  margin: 0 auto;
`;

export const ButtonBlock = styled.div`
  width: 70%;
  display: flex;
  justify-content: center;
  margin: 20px auto 0;
`;

const activeClassName = 'active';

export const StyledLink = styled(NavLink).attrs({
  activeClassName: activeClassName,
})`
  display: block;
  text-align: center;
  height: 100%;
  border-radius: 8px;
  padding: 0 10px;
  color: #ffffff;
  line-height: 50px;
  text-decoration: none;
  transition: all 0.3s;
  background: #17ade3;
  &:hover {
    background: #157aac;
    color: #ffffff;
  }
  @media (max-width: 345px) {
    font-size: 14px;
  }
  &.${activeClassName} {
    background: #157aac;
  }
`;

export const FooterBlock = styled.div`
  height: 50px;
`;



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/CreateProductPage/CreateProductStyles.js